/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createTechnicalAccount } from '../fn/technical-accounts/create-technical-account';
import { CreateTechnicalAccount$Params } from '../fn/technical-accounts/create-technical-account';
import { deleteTechnicalAccount } from '../fn/technical-accounts/delete-technical-account';
import { DeleteTechnicalAccount$Params } from '../fn/technical-accounts/delete-technical-account';
import { getAllTechnicalAccounts } from '../fn/technical-accounts/get-all-technical-accounts';
import { GetAllTechnicalAccounts$Params } from '../fn/technical-accounts/get-all-technical-accounts';
import { getTechnicalAccount } from '../fn/technical-accounts/get-technical-account';
import { GetTechnicalAccount$Params } from '../fn/technical-accounts/get-technical-account';
import { searchTechnicalAccount } from '../fn/technical-accounts/search-technical-account';
import { SearchTechnicalAccount$Params } from '../fn/technical-accounts/search-technical-account';
import { TechnicalAccount } from '../models/technical-account';
import { TechnicalAccountList } from '../models/technical-account-list';
import { updateTechnicalAccount } from '../fn/technical-accounts/update-technical-account';
import { UpdateTechnicalAccount$Params } from '../fn/technical-accounts/update-technical-account';

@Injectable({ providedIn: 'root' })
export class TechnicalAccountsService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllTechnicalAccounts()` */
  static readonly GetAllTechnicalAccountsPath = '/technical-accounts';

  /**
   * Get technical accounts.
   *
   * Get all technical accounts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTechnicalAccounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTechnicalAccounts$Response(params?: GetAllTechnicalAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccountList>> {
    return getAllTechnicalAccounts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get technical accounts.
   *
   * Get all technical accounts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTechnicalAccounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTechnicalAccounts(params?: GetAllTechnicalAccounts$Params, context?: HttpContext): Observable<TechnicalAccountList> {
    return this.getAllTechnicalAccounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<TechnicalAccountList>): TechnicalAccountList => r.body)
    );
  }

  /** Path part for operation `createTechnicalAccount()` */
  static readonly CreateTechnicalAccountPath = '/technical-accounts';

  /**
   * Create a technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTechnicalAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTechnicalAccount$Response(params: CreateTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTechnicalAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTechnicalAccount(params: CreateTechnicalAccount$Params, context?: HttpContext): Observable<void> {
    return this.createTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTechnicalAccount()` */
  static readonly GetTechnicalAccountPath = '/technical-accounts/{uid}';

  /**
   * Get a technical account.
   *
   * Get a technical account
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechnicalAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechnicalAccount$Response(params: GetTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccount>> {
    return getTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a technical account.
   *
   * Get a technical account
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTechnicalAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechnicalAccount(params: GetTechnicalAccount$Params, context?: HttpContext): Observable<TechnicalAccount> {
    return this.getTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<TechnicalAccount>): TechnicalAccount => r.body)
    );
  }

  /** Path part for operation `updateTechnicalAccount()` */
  static readonly UpdateTechnicalAccountPath = '/technical-accounts/{uid}';

  /**
   * Update a technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTechnicalAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTechnicalAccount$Response(params: UpdateTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTechnicalAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTechnicalAccount(params: UpdateTechnicalAccount$Params, context?: HttpContext): Observable<void> {
    return this.updateTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTechnicalAccount()` */
  static readonly DeleteTechnicalAccountPath = '/technical-accounts/{uid}';

  /**
   * Deactivate a technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTechnicalAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTechnicalAccount$Response(params: DeleteTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Deactivate a technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTechnicalAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTechnicalAccount(params: DeleteTechnicalAccount$Params, context?: HttpContext): Observable<void> {
    return this.deleteTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchTechnicalAccount()` */
  static readonly SearchTechnicalAccountPath = '/technical-accounts/search';

  /**
   * Search through all technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTechnicalAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchTechnicalAccount$Response(params?: SearchTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccountList>> {
    return searchTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Search through all technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTechnicalAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchTechnicalAccount(params?: SearchTechnicalAccount$Params, context?: HttpContext): Observable<TechnicalAccountList> {
    return this.searchTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<TechnicalAccountList>): TechnicalAccountList => r.body)
    );
  }

}
